import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction, userActions } from "../../_actions";
import { AppTable } from "../../_components/AppTable";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
  Modal,
  Spin,
  Space,
} from "antd";
import { Document1 } from "./ReportDocuments/Document_1";
import { Document2 } from "./ReportDocuments/Document_2";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import ReportsTable from "./ReportsTable";
import * as XLSX from "xlsx-js-style";
import moment from "moment";

const TableReport3 = React.lazy(() =>
  import("./Tables/Table3").then((module) => ({
    default: module.TableReport3,
  }))
);

const { RangePicker } = DatePicker;
const { Option } = Select;

class Reports3 extends React.Component {
  constructor(props) {
    super(props);
    this.myTableRef = React.createRef();
  }

  state = {
    loading: false,
    downloadLoding: false,
    report_1_startDate: "",
    report_1_endDate: "",
    report1_loader: false,
    report1_List: [],
    report1_List_Total: null,
    report1_API_loader: false,
    report1_List_Inactive_Total: null,
    download: "",
  };

  downloadReport1 = async () => {
    const { user } = this.props;
    let obj = {
      startDate: this.state.report_1_startDate,
      endDate: this.state.report_1_endDate,
      cityId: user && user.cityId,
    };
    this.setState({
      report1_loader: true,
    });
    const blob = await pdf(
      <Document1
        rows={this.state.report1_List}
        filterDate={obj}
        total={this.state.report1_List_Total}
      />
    ).toBlob();

    if (blob) {
      this.setState({
        report1_loader: false,
      });
      saveAs(blob, "पोलिस स्टेशन निहाय गस्त आकडेवारी अहवाल");
    }
  };

  download_csv = () => {
    var ReportTitle = "पोलिस स्टेशन निहाय गस्त आकडेवारी अहवाल";
    var title = "पोलिस_स्टेशन_निहाय_गस्त_आकडेवारी_अहवाल";
    var arrData1 = this.state.report1_List;
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const list =
      arrData1?.map((data, index) => ({
        "अ.क्र": index + 1,
        "पो स्टे हद्दीतील आरोपी": data.policeThane,
        "एकूण आरोपी": data.remainingCriminals,
        "एकूण तपासले": data.totalCriminalsChecked,
        "मिळून आलेला": data.totalFindCriminals,
        "मिळून न आलेला": data.totalUnFindCriminals,
        "उर्वरित आरोपी": data.totalCriminals,
      })) || [];

    const arrData = list;

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length)
        ) + 6,
    }));

    const headerStyle = {
      font: { bold: true, sz: 12 },
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true,
      },
    };
    ws["!cols"] = columnWidths;
    Object.keys(arrData[0]).forEach((key, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 2, c: index }); // Headers are at row 3 (A3)
      if (!ws[cellRef]) ws[cellRef] = {}; // Ensure cell exists
      ws[cellRef].s = headerStyle;
    });

    ws["A1"] = {
      v: this.getCityName(this.props?.user?.cityId || ""),
      t: "s",
      s: headerStyle,
    };
    ws["A2"] = { v: ReportTitle, t: "s", s: headerStyle };

    // Date Row Only for Non-'history_sheeter'

    ws["A3"] = {
      v: `${moment(this.state.report_1_startDate).format("DD-MM-YYYY")}`,
      t: "s",
      s: headerStyle,
    };

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY"
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { bold: true, sz: 12, color: { rgb: "000000" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
    ];

    mergeRanges.push({
      s: { r: 2, c: 0 },
      e: { r: 2, c: columnWidths.length - 1 },
    });

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  generatePDFReport1 = async () => {
    const { user } = this.props;
    let obj = {
      startDate: this.state.report_1_startDate,
      endDate: this.state.report_1_endDate,
      cityId: user && user.cityId,
    };
    this.setState({
      report1_API_loader: true,
    });
    professionalAction.getReport3(obj).then((res) => {
      res &&
        res &&
        res.text().then(async (text) => {
          const tempData = text && JSON.parse(text);
          const tempFilterData = _.filter(
            tempData && tempData.data && _.flatten(tempData.data),
            function (o) {
              return Object.keys(o).length !== 0;
            }
          );
          this.setState({
            report1_API_loader: false,
            report1_List: tempFilterData,
            report1_List_Total: tempData && tempData.allTotalCriminals,
            report1_List_Inactive_Total:
              tempData && tempData.allTotalInactiveCriminals,
          });
        });
    });
  };

  onFinishDateRangeGPSTable = (values) => {
    if (values) {
      this.setState({
        report_3_startDate: values.toISOString(),
      });
    }
  };

  onFinishDateRangeGPSReport1 = (values) => {
    if (values) {
      this.setState({
        report_1_startDate: values.toISOString(),
      });
    }
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  isloading = () => {
    this.setState({ loading: true });
  };

  isNotloading = () => {
    this.setState({ loading: false });
  };

  handleDownload = () => {
    console.log("handleDownload", this.myTableRef.current);
    if (this.myTableRef.current) {
      this.myTableRef.current.handleDownloadPDF();
    }
    this.isloading();
  };

  downloadReport = () => {
    const { download } = this.state;
    if (download == "excel") {
      this.download_csv();
    }
    if (download == "pdf") {
      this.handleDownload();
    }
  };
  render() {
    const { users } = this.props;
    const { user } = this.props;
    const { professionals } = this.props;
    const { pc_cities, loading } = professionals;

    return (
      <Spin spinning={this.state.loading} delay={500}>
        <div className="col-md-6 col-md-offset-3">
          <div className="site-page-header-ghost-wrapper">
            <PageHeader
              className="site-page-header"
              ghost={false}
              onBack={false}
              title={user && user.userid}
              subTitle={
                user && user.role === "4" ? "( ADMIN )" : "( SUPER ADMIN )"
              }
            ></PageHeader>
            <PageHeader
              className="site-page-header"
              ghost={false}
              onBack={false}
              title={"पोलिस स्टेशन निहाय गस्त आकडेवारी अहवाल"}
              // extra={[
              //   <Button
              //     key="1"
              //     type="primary"
              //     disabled={!this.state.report1_List.length}
              //     loading={this.state.report1_loader}
              //     onClick={this.downloadReport1}
              //   >
              //     Download
              //   </Button>,
              // ]}
            >
              <Descriptions size="small" column={2}>
                <Descriptions.Item label="Select Date">
                  <DatePicker
                    style={{ marginRight: 10 }}
                    onChange={(val) => this.onFinishDateRangeGPSReport1(val)}
                    inputReadOnly
                  />
                  <Button
                    key="1"
                    type="primary"
                    disabled={!this.state.report_1_startDate}
                    loading={this.state.report1_API_loader}
                    onClick={this.generatePDFReport1}
                  >
                    Find
                  </Button>
                  <div style={{ paddingLeft: "45%" }}>
                    {/* download report show as drodown */}
                    {/* <Button
                      key="1"
                      type="primary"
                      disabled={!this.state.report1_List.length}
                      loading={this.state.report1_loader}
                    >
                      Download
                    </Button>
                    <Space>
                      <Button
                        type="primary"
                        icon={<FilePdfOutlined />}
                        onClick={this.handleDownload}
                        disabled={!this.state.report1_List.length}
                        style={{ marginLeft: "10px" }}
                      />
                      <Button
                        type="primary"
                        icon={<FileExcelOutlined />}
                        onClick={this.download_csv}
                        disabled={!this.state.report1_List.length}
                      />
                    </Space> */}
                    <Space direction="horizontal" size="middle">
                      <Form>
                        <Form.Item
                          name="condition"
                          rules={[
                            {
                              required: true,
                              message: "Please select a value",
                            },
                          ]}
                          style={{ marginBottom: 0 }}
                        >
                          <Select
                            placeholder="कृपया पर्याय निवडा"
                            value={this.state.download}
                            onChange={(value) =>
                              this.setState({ download: value })
                            }
                            style={{ width: 150 }}
                            disabled={!this.state.report1_List.length}
                          >
                            <Option key="excel" value="excel">
                              एक्सेल
                            </Option>
                          </Select>
                        </Form.Item>
                      </Form>

                      {this.state.download && (
                        <Button
                          key="1"
                          type="primary"
                          style={{ minWidth: 120 }}
                          onClick={() => this.downloadReport()}
                        >
                          Download
                        </Button>
                      )}
                    </Space>
                  </div>
                </Descriptions.Item>
              </Descriptions>
            </PageHeader>
            <React.Suspense fallback={<div>Loading...</div>}>
              <TableReport3
                data={this.state.report1_List}
                total={this.state.report1_List_Total}
                Inactive_count={this.state.report1_List_Inactive_Total}
              ></TableReport3>
            </React.Suspense>
          </div>
        </div>
        <ReportsTable
          isNotloading={this.isNotloading}
          ref={this.myTableRef}
          rows={this.state.report1_List}
          startDate={this.state.report_1_startDate}
          endDate={this.state.report_1_endDate}
          cityId={
            this.props ? this.props?.user && this.props?.user.cityId : null
          }
          heading="पोलिस स्टेशन निहाय गस्त आकडेवारी अहवाल"
          allTotal={this.state.totalCriminal}
          total={this.state.report1_List_Total}
          cityName={this.getCityName(
            this.props?.user && this.props?.user.cityId
          )}
          user={this.props?.user?.role}
          report_type="गस्त_आकडेवारी"
          report_name="पोलिस स्टेशन निहाय गस्त आकडेवारी अहवाल"
        />
      </Spin>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connectedReports3 = connect(mapStateToProps)(Reports3);
export { connectedReports3 as Reports3 };
